module.exports = __webpack_public_path__ + "img/ios-search.58de3086.svg";